/*
 * 模块: useMetrics Hook
 * 职责: 管理指标定义的状态和数据加载
 * 依赖: api服务、类型定义
 * 导出: useMetrics hook
 * 限制: 文件<280行, 函数<30行
 */

import { useState, useEffect } from 'react';
import { message } from 'antd';
import api from '../../../services/api';
import type { MetricDefinition } from '../../../types';

interface UseMetricsReturn {
  metrics: Record<string, MetricDefinition>;
  loading: boolean;
  filterMetrics: (category: string, searchTerm?: string) => [string, MetricDefinition][];
}

export const useMetrics = (searchTerm: string = ''): UseMetricsReturn => {
  const [metrics, setMetrics] = useState<Record<string, MetricDefinition>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMetricsDefinitions();
  }, []);

  const loadMetricsDefinitions = async () => {
    try {
      setLoading(true);
      const response = await api.get('/metrics-definitions/');
      setMetrics(response.data);
    } catch (error) {
      message.error('加载指标定义失败');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const filterMetrics = (category: string, term: string = searchTerm) => {
    return Object.entries(metrics)
      .filter(([_, def]) => def.category === category)
      .filter(([key, def]) => {
        if (!term) return true;
        const lowerTerm = term.toLowerCase();
        return (
          def.name.toLowerCase().includes(lowerTerm) ||
          def.short_desc.toLowerCase().includes(lowerTerm) ||
          key.toLowerCase().includes(lowerTerm)
        );
      });
  };

  return {
    metrics,
    loading,
    filterMetrics,
  };
};

